import { combineReducers, configureStore } from '@reduxjs/toolkit';

import applicationNotificationsReducer from './slices/applicationNotifications';
import applicationReducer from './slices/applicationSlice';
import authReducer from './slices/authSlice';
import builderStoreReducer from './slices/builderStoreSlice';
import conditionalLogicReducer from './slices/conditionalLogicSlice';
import propertiesReducer from './slices/propertiesSlice';
import unsavedFieldReducer from './slices/unsavedFieldSlice';
import userReducer from './slices/userSlice';
import { RootState } from './store';

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

const rootReducer = combineReducers({
  auth: authReducer,
  applicationNotifications: applicationNotificationsReducer,
  application: applicationReducer,
  builderStore: builderStoreReducer,
  properties: propertiesReducer,
  user: userReducer,
  unsavedField: unsavedFieldReducer,
  conditionalLogic: conditionalLogicReducer,
});
